import React from "react";
import { Typography } from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";
import { useHistory } from "react-router-dom";

import "./PasswordResetSuccessView.css";
import logoImage from "../../../assets/CRMAssets/psconnect_login_logo@2x.png";
import { ArrowPrimaryButton } from "../../../components/Buttons/PrimaryButton";

function PasswordResetSuccessView() {
  const history = useHistory();

  return (
    <div className="passwordResetSuccessPage">
      <div className="passwordResetSuccessOverlay"></div>

      <div className="passwordResetSuccessContainer">
        <div className="passwordResetSuccessCard">

          {/* Logo */}
          <div className="passwordResetSuccessLogoWrapper">
            <img
              src={logoImage}
              alt="PS Connect"
              className="passwordResetSuccessLogo"
            />
          </div>

          {/* Success Icon */}
          <div className="passwordResetSuccessIcon">
            <CheckCircleOutline
              style={{
                color: "#16C05B",
                fontSize: 54,
              }}
            />
          </div>

          {/* Heading */}
          <Typography className="passwordResetSuccessTitle">
            Password Reset!
          </Typography>

          {/* Description */}
          <Typography className="passwordResetSuccessDescription">
            Your password has been successfully updated.
            <br />
            You can now log in with your new password.
          </Typography>

          {/* Button */}
          <div className="passwordResetSuccessButtonWrapper">
  <ArrowPrimaryButton
    fullWidth
    onClick={() => history.push("/login")}
  >
    BACK TO LOGIN
  </ArrowPrimaryButton>
</div>

        </div>
      </div>
    </div>
  );
}

export default PasswordResetSuccessView;